@if (modelGroup) {
  <form [formGroup]="form" class="row" style="align-content: space-between">
    <div class="col-3">
      <input formControlName="code" style="float: left">
    </div>
    <div class="col-3">
      <input formControlName="description">
    </div>
    <div class="col-3">
      <select formControlName="make" [compareWith]="brandsEqual">
        <option [value]="null">{{''|i18n:'select'}}</option>
        @for (make of brands; track make) {
          <option [ngValue]="make">{{make.name}}</option>
        }
      </select>
    </div>
    <section class="col-3">
      @if (newModelGroup) {
        <button (click)="emit()">
          {{''| i18n:'cancel'}}
        </button>
      }
      <button [disabled]="!form.valid" (click)="save()">
        {{saveOrUpdateButtonText()}}
      </button>
    </section>
  </form>
}
<hr/>
